// PRD-64 WP3 (2026-05-31): browser-side mirror of api/shared/riskBands.js. Bands must
// match the API helper; parity is asserted by api/shared/riskBands.test.js. Wizard adds
// a `message` field per band (UX copy) that the email side doesn't need.

const BANDS = [
  { min: 70, label: 'Critical', color: 'var(--severity-critical)', message: 'Your external attack surface has critical vulnerabilities that could be exploited today. We recommend immediate action.' },
  { min: 50, label: 'High',     color: 'var(--severity-high)',     message: 'Several significant security issues were detected. These should be addressed within the next few days.' },
  { min: 30, label: 'Medium',   color: 'var(--severity-medium)',   message: 'Your security posture has room for improvement. Review the findings and prioritize the high-severity items.' },
  { min: 15, label: 'Low',      color: 'var(--severity-low)',      message: 'Your attack surface is in reasonable shape. A few items to address, but no critical exposures.' },
  { min: 0,  label: 'Minimal',  color: 'var(--severity-low)',      message: 'Excellent security posture. Only minor informational findings detected.' }
];

export function getRiskContext(score) {
  if (score === null || score === undefined || Number.isNaN(score)) return null;
  const clamped = Math.max(0, Math.min(100, Number(score)));
  for (const band of BANDS) {
    if (clamped >= band.min) return { ...band };
  }
  return { ...BANDS[BANDS.length - 1] };
}

export { BANDS };
